module.exports = __webpack_public_path__ + "static/img/005.b5b84d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/005.png
// module id = BInQ
// module chunks = 0